import { render } from "./BlocksSaveBar.vue?vue&type=template&id=591ff1c9"
import script from "./BlocksSaveBar.vue?vue&type=script&lang=js"
export * from "./BlocksSaveBar.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__